import React from 'react';
import Layout from './Shared/Layout';
import Callout from '../Components/Callout';
import Hero from '../Components/Hero';

const Main = () => {
    return ( 
        <Layout className="position-relative">
            <Hero />
            <Callout />
        </Layout>
     );
}
 
export default Main;